import { z } from "zod";
import { EVENT_BLOCK_TYPES, POLL_TYPES } from "../types/event-tabs.js";

export const createBlockSchema = z.object({
  block_type: z.enum(EVENT_BLOCK_TYPES),
  title: z.string().min(1).max(200),
  body: z.string().max(20000).optional().nullable(),
  // 178 -- free-form per-block blob; bound key count + serialized size so it
  // can't be used to store an unbounded payload.
  meta: z
    .record(z.string(), z.unknown())
    .refine((o) => Object.keys(o).length <= 50, {
      message: "meta may have at most 50 keys",
    })
    .refine((o) => JSON.stringify(o).length <= 20000, {
      message: "meta is too large",
    })
    .default({}),
  sort_order: z.number().int().optional(),
  visible: z.boolean().optional(),
});

export const updateBlockSchema = createBlockSchema.partial();

export const reorderBlocksSchema = z.object({
  order: z.array(z.string().min(1)).min(1),
});

const pollOptionSchema = z.object({
  label: z.string().min(1).max(200),
  value: z.string().min(1).max(100),
  max_signups: z.number().int().positive().optional().nullable(),
});

export const createPollSchema = z.object({
  question: z.string().min(1).max(500),
  poll_type: z.enum(POLL_TYPES),
  options: z.array(pollOptionSchema).min(2).max(20),
  closes_at: z.string().datetime().optional().nullable(),
});

export const respondPollSchema = z.object({
  option_value: z.string().min(1),
  note: z.string().max(500).optional().nullable(),
});

export type CreateBlockInput = z.infer<typeof createBlockSchema>;
export type UpdateBlockInput = z.infer<typeof updateBlockSchema>;
export type ReorderBlocksInput = z.infer<typeof reorderBlocksSchema>;
export type CreatePollInput = z.infer<typeof createPollSchema>;
export type RespondPollInput = z.infer<typeof respondPollSchema>;
